// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___1IgSI","name":"styles__name___3DjKt","avatar":"styles__avatar___2fVeP","department":"styles__department___1Qx2O","rotate":"styles__rotate___5QVss","fadein":"styles__fadein___134zp","slideFromRight":"styles__slideFromRight___1_L3s","waves":"styles__waves___Vaxg7"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/FacultyList/styles.scss
// module id = ./resources/assets/js/components/FacultyList/styles.scss
// module chunks = 0